import React from 'react';
import { createLink, _t } from 'utils';
import Section from 'screens/shared/section';
import { ACTIONS_TYPES, actions } from 'redux/local';
import { withRouter } from 'react-router-dom';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default withRouter(({
  cdroms = [], history = {}, match, readonly = false,
}) => {
  const { dcId, id: serverId } = match?.params;

  const clickHandler = ({ id: cdRomId }) => {
    // eslint-disable-next-line object-curly-newline
    history.push(createLink(ROUTE.DASHBOARD.STORAGE_IN_SERVER, { dcId, serverId, id: cdRomId, type: 'cdrom' }));
  };

  const deleteHandler = ({ id: cdRomId }) => {
    actions.server.deattachCdRom({ cdRomId, dcId, id: serverId });
  };

  return (
    <Section
      sectionTitle={_t('CD-Roms')}
      itemIcon="compact-disc"
      className="p-t-40"
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => (
        <div>
          <span>{`${e?.properties?.size} GB`}</span>
          {!!e?.isBootable && <span className="m-l-15 color-success">Boot</span>}
        </div>
      )}
      itemOnDelete={deleteHandler}
      itemOnClick={clickHandler}
      items={cdroms}
      isDeletePassword
      createForm={<CreateForm />}
      createActionType={ACTIONS_TYPES.SERVER.ATTACH_CD_ROM}
      isAddButton={!readonly}
    />
  );
});
